import React, { useEffect, useState } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot';
import CountDownFunctionality from '../countdownTimer-component/date-countdown';
import { endOfDecadeWithOptions } from 'date-fns/fp';
var FlexSpotReactComponent = function FlexSpotReactComponent(_ref) {
  var settings = _ref.settings;
  var keyCounter = 0;
  var getClasses = function getClasses(element) {
    var classes = '';
    for (var i = 0; i < element.length; i++) {
      classes += "".concat(element[i], " ");
    }
    return classes;
  };
  var bg = null;
  var preElement = settings.preElementItems.map(function (preEl) {
    if (preEl.tag == "countdown-background") {
      bg = preEl.image.src;
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: getClasses(preEl.classes),
      key: keyCounter++,
      "data-tag": preEl.tag,
      dangerouslySetInnerHTML: {
        __html: "".concat(preEl.html.html)
      }
    });
  });
  var theDate = null;
  var timerText = {};
  var elements = settings.elements.map(function (el) {
    var items = el.items.map(function (item) {
      if (item.tag == "end-date") {
        var date = item.html.html;
        var dateArr = date.split('-');
        theDate = new Date(Date.UTC(dateArr[0], dateArr[1] - 1, dateArr[2], dateArr[3], dateArr[4]));
        return;
      }
      if (item.tag == "timer-text") {
        var text = item.html.html;
        var textArr = text.split('<p>');
        timerText.days = textArr[1].replace('</p>', '').replace(':', '');
        timerText.hours = textArr[2].replace('</p>', '').replace(':', '');
        timerText.minutes = textArr[3].replace('</p>', '').replace(':', '');
        timerText.seconds = textArr[4].replace('</p>', '').replace(':', '');
        return;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: getClasses(item.classes),
        key: keyCounter++,
        "data-tag": header,
        dangerouslySetInnerHTML: {
          __html: "".concat(item.html.html)
        }
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      key: keyCounter++,
      className: "element"
    }, items);
  });
  var postElement = settings.postElementItems.map(function (postEl) {
    return /*#__PURE__*/React.createElement("div", {
      className: getClasses(postEl.classes),
      key: keyCounter++,
      "data-tag": postEl.tag,
      dangerouslySetInnerHTML: {
        __html: "".concat(postEl.html.html)
      }
    });
  });
  var timerComponents = CountDownFunctionality(theDate, timerText);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex-spot-background-img",
    style: {
      backgroundImage: "url(".concat(bg, ")")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "preElement"
  }, preElement), /*#__PURE__*/React.createElement("div", {
    className: "element timerComponent"
  }, timerComponents), /*#__PURE__*/React.createElement("div", {
    className: "postElement"
  }, postElement));
};
var c = new ComponentBootstrap('.flex-spot.countdown-timer');
c.schemaData = flexSpotSchema;
c.reactApp = FlexSpotReactComponent;
c.onResize = function (component) {
  component.style.display = 'block';
};
c.run();